<template>
<div class="box">

  <!-- 公共顶部 -->
  <van-nav-bar title="订单支付"  >
  <template #left>
   <van-icon name="arrow-left" @click="toPath" color="#FFFFFF" size="24"/>
  </template>
  </van-nav-bar>
  <div class="box_con">

    <div class="info">
          <div class="p">
              <div class="name">货品名称：</div>
              <div class="name">{{goodsName}}</div>
          </div>
          <div class="p" style=" border-top: 1px dashed #333333;">
              <div class="name">支付金额(元):</div>
              <div class="name" style="color:#FF0000">{{totalPayment}}</div>
          </div>
          <div class="content">
            请在微信/支付宝内长按识别二维码或者使用微信/支付宝扫描二维码完成订单付款，付款后付款状态不会立即改变.
          </div>
    </div>
      <div class="info">
          <!-- <div class="p"> -->
              <div class="name" style="font-size:16px;margin-bottom:5px;line-height:24px">付款时请备注：<br> 订单号:{{orderNo}}</div>
          <!-- </div> -->
          <div class="content">
            该收款码为商家账户，请务必确认收款人信息
          </div>
      </div>
        <div class="info">
          <div class="height">
                  <img  class="find" style="height: 100%;width: 100%;opacity: 0" :src="img">
              <div class="c" v-for="itme in list" :key="itme.id">
                <!-- <div v-if="itme.status==1" class="c_tit">{{itme.payType=='wx'?'微信':'支付宝'}}收款码</div> -->
                <img  :src="itme.payCode" class="code" alt="">
              </div>
          </div>
        </div>
  </div>
  <!-- <div class="statement">
    <div class="s_tit">免责声明</div>
    <div class="s_con">查询结果仅代表使用者的工作记,其销售关系与本公司无关</div>
    <div class="s_con">Copyright @ 2016-2021 bbtyy1127.cn</div>
  </div> -->
</div>
</template>
<script>
import {getPay} from '@/api/login'
export default {
  data () {
    return {
      goodsName:this.$route.query.goodsName, 
      totalPayment:this.$route.query.totalPayment, 
      orderNo:this.$route.query.orderNo,
      list:[],
      img:''     
    }
  },
  created(){
this.getPay()
  },
  methods: {
   
    toPath(){
      this.$router.push('/home')
    },
    getPay(){
      getPay().then(res=>{
        this.list=res.data.rows
        this.img=res.data.rows[0].payCode
        console.log(res.data.rows[0].payCode)
        console.log(this.img)
      })
    }
  }
}
</script>
<style scoped lang='less'>
.content{
  font-size: 14px;
  color: #666666;
  letter-spacing: 1px;
}
.find{
   position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  right: 0;
}

.code{
  width: 170px;
  height: 170px;
  // user-select: auto;
    // pointer-events: auto;
          // -webkit-touch-callout: auto;
    // -webkit-touch-callout: none;
      // -moz-user-select: auto;
          // -webkit-user-select: auto;
          // -o-user-select: auto;
}
.height{
  position: relative;
  // height: 150px !important;
  text-align: center;
}
.c{
  display: inline-block;
  .c_tit{
    font-size: 14px;
    color: #666666;
    margin-bottom: 5px;
  }
}
.box{
  width: 100%;
  height: 100vh;
  background-color: #BAB2D1;
  padding-top: 47px;
 -webkit-touch-callout: none;
  box-sizing: border-box;
  .box_con{
    width: 100%;
    padding: 15px 20px;
    box-sizing: border-box;
    .info{
      width: 100%;
      padding: 15px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 10px;
      padding-top: 8px;
      margin-bottom: 20px;
      .p{
         display: flex;
         height: 48px;
         line-height: 48px;
        justify-content: space-between; /* 横向中间自动空间 */
        align-content: space-between; 
        .name{
          font-size: 16px;
          color: #333333;
          vertical-align: top;
        }
      }
     
    }
  }
  .statement{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px;
    box-sizing: border-box;
    text-align: center;
    color: #FFFFFF;
    .s_tit{
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .s_con{
      font-size: 12px;
      font-size: 500;
    }
  }
  /deep/.van-search__content{
    padding-left: 16px !important;
  }
  /deep/.van-nav-bar{
    height: 46px;
    background-color: #BAB2D1;
  }
  /deep/.van-nav-bar__title{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

}

</style>
